import FilterTypes from '@constants/FilterTypes';
import { translate } from '@utils/i18n';
import { hasGlobalTerritoriesApplied } from '../../../helpers/territories';
import { actionTypes } from '../reducer';
const STATUS_NS = 'features.ai_to_review_inspections.index.status_cards';
const IIM_REVIEW_STATUS_OPTIONS = [
    { title: translate('not_started', { namespace: STATUS_NS }), value: 'iim_not_started' },
    { title: translate('in_progress', { namespace: STATUS_NS }), value: 'iim_in_progress' },
    { title: translate('sent_for_correction', { namespace: STATUS_NS }), value: 'iim_sent_for_correction' }
];
const onToggleFilter = (fieldName, dispatch) => {
    return () => {
        dispatch({
            type: actionTypes.FILTER_TOGGLED,
            field: fieldName
        });
    };
};
const onChangeDateFilter = (fieldName, dispatch) => {
    return (dateFieldName, value) => {
        dispatch({
            type: actionTypes.DATE_RANGE_FILTER_CHANGED,
            field: fieldName,
            dateField: dateFieldName,
            value
        });
    };
};
const getFiltersList = ({ filters, dispatch, frequenciesForSelect, assetsForSelect, statusesForSelect }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const onChange = (filterKey, value) => {
        const newValues = Object.assign(Object.assign({}, filters.values), { [filterKey]: value });
        dispatch({
            type: actionTypes.FILTER_CHANGED,
            filters: Object.assign(Object.assign({}, filters), { values: newValues })
        });
    };
    const filtersList = [
        {
            type: FilterTypes.DateRangePicker,
            field: 'scheduledDate',
            locale: 'scheduled_date',
            active: !!((_a = filters.active) === null || _a === void 0 ? void 0 : _a.scheduledDate),
            values: filters.values.scheduledDate || '',
            onChange: onChangeDateFilter('scheduledDate', dispatch),
            onToggle: onToggleFilter('scheduledDate', dispatch)
        },
        {
            type: FilterTypes.GenericMultiSelect,
            field: 'frequency',
            locale: 'frequency',
            active: !!((_b = filters.active) === null || _b === void 0 ? void 0 : _b.frequency),
            value: filters.values.frequency || '',
            optionsForSelect: frequenciesForSelect.map((opt) => ({
                title: opt.label,
                value: opt.value
            })),
            onChange: (value) => onChange('frequency', value),
            onToggle: onToggleFilter('frequency', dispatch)
        },
        {
            type: FilterTypes.GenericMultiSelect,
            field: 'building',
            locale: 'building',
            active: !!((_c = filters.active) === null || _c === void 0 ? void 0 : _c.building),
            value: filters.values.building || '',
            onChange: (value) => onChange('building', value),
            onToggle: onToggleFilter('building', dispatch)
        },
        {
            type: FilterTypes.GenericMultiSelect,
            field: 'technician',
            locale: 'technician',
            active: !!((_d = filters.active) === null || _d === void 0 ? void 0 : _d.technician),
            value: filters.values.technician || '',
            onChange: (value) => onChange('technician', value),
            onToggle: onToggleFilter('technician', dispatch),
            withUnassigned: true,
            allowLetterAvatar: true
        },
        {
            type: FilterTypes.DateRangePicker,
            field: 'inspectionDate',
            locale: 'inspection_date',
            active: !!((_e = filters.active) === null || _e === void 0 ? void 0 : _e.inspectionDate),
            values: filters.values.inspectionDate || '',
            onChange: onChangeDateFilter('inspectionDate', dispatch),
            onToggle: onToggleFilter('inspectionDate', dispatch)
        },
        {
            type: FilterTypes.GenericMultiSelect,
            field: 'inspectionStatus',
            locale: 'inspection_status',
            active: !!((_f = filters.active) === null || _f === void 0 ? void 0 : _f.inspectionStatus),
            value: filters.values.inspectionStatus || '',
            optionsForSelect: statusesForSelect.map((opt) => ({ title: opt.label, value: opt.value, icon: opt.icon, color: opt.color })),
            disableSorting: true,
            onChange: (value) => onChange('inspectionStatus', value),
            onToggle: onToggleFilter('inspectionStatus', dispatch)
        },
        {
            type: FilterTypes.TreeMultiSelect,
            field: 'asset',
            locale: 'asset',
            active: !!((_g = filters.active) === null || _g === void 0 ? void 0 : _g.asset),
            value: filters.values.asset || [],
            optionsForSelect: assetsForSelect,
            onChange: (value) => onChange('asset', value),
            onToggle: onToggleFilter('asset', dispatch)
        },
        {
            type: FilterTypes.GenericMultiSelect,
            field: 'iimReviewStatus',
            locale: 'iim_review_status',
            active: !!((_h = filters.active) === null || _h === void 0 ? void 0 : _h.iimReviewStatus),
            value: filters.values.iimReviewStatus || '',
            optionsForSelect: IIM_REVIEW_STATUS_OPTIONS,
            onChange: (value) => onChange('iimReviewStatus', value),
            onToggle: onToggleFilter('iimReviewStatus', dispatch)
        }
    ];
    // Add territory filter only if global territories are not applied
    if (!hasGlobalTerritoriesApplied()) {
        filtersList.push({
            type: FilterTypes.GenericMultiSelect,
            field: 'territory',
            locale: 'territory',
            active: !!((_j = filters.active) === null || _j === void 0 ? void 0 : _j.territory),
            value: filters.values.territory || '',
            onChange: (value) => onChange('territory', value),
            onToggle: onToggleFilter('territory', dispatch),
            withUnassigned: true
        });
    }
    return filtersList;
};
export default getFiltersList;
